module.exports = __webpack_public_path__ + "img/emoji-message-bubble-80x80.ece1390a.png";